import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import withStyles from 'react-jss';

const styles = {
  root: {},
  buttons: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    justifyContent: 'space-between',
  },
  slider: {
    width: '100%',
    margin: '10px 0',
  },
};

const SliderConfirmation = ({
  classes,
  open,
  ok = 'Ok',
  cancel = 'Cancel',
  onConfirm,
  onCancel,
  children,
}) => {
  const handleOk = () => {
    onConfirm && onConfirm();
  };

  const handleCancel = () => {
    onCancel && onCancel();
  };
  const [sliderValue, setSliderValue] = useState(0);

  return (
    <Modal open={open} onClose={handleCancel} className={classes.root}>
      {children ? children : <p>Are you sure?</p>}
      <div>Please put the slider to the right to confirm</div>
      <input
        className={classes.slider}
        type='range'
        min='0'
        max='3'
        value={sliderValue}
        onChange={(e) => setSliderValue(e.target.value)}
      />
      <div className={classes.buttons}>
        <Button onClick={handleOk} disabled={sliderValue !== '3'}>
          {ok}
        </Button>
        <Button onClick={handleCancel}>{cancel}</Button>
      </div>
    </Modal>
  );
};

export default withStyles(styles)(SliderConfirmation);
